import React from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../firebase';
import AuthUserContext from './context';
import * as ROUTES from '../../constants/routes';

const withAuthorization = condition => Component => {

  class WithAuthorization extends React.Component {

    componentDidMount() {
      this.listener = this.props.firebase.auth.onAuthStateChanged(async authUser => {

        if (!!authUser) {
          const user = this.props.firebase.auth.currentUser;
          const idTokenResult = await user.getIdTokenResult();
          authUser.token = idTokenResult.claims;
          if (!condition(authUser))
            this.props.history.push(ROUTES.HOME);

        } else {
          this.props.history.push(ROUTES.LOGIN);
        }

      },
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {authUser =>
            condition(authUser) ? <Component {...this.props} /> : null
          }
        </AuthUserContext.Consumer>
      );
    }

  }

  return withRouter(withFirebase(WithAuthorization));
}

export default withAuthorization;